// src/components/BottomNav.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNav.css';

const HomeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const ScheduleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
  </svg>
);

const MapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const AccountIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const BottomNav = () => {
  const location = useLocation();
  const path = location.pathname;

  // Scroll to top when tapping Home while already on the dashboard
  const handleHomeClick = (e) => {
    if (path === '/dashboard') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  };

  return (
    <nav className="mobile-nav">
      <Link
        to="/dashboard"
        className={`mobile-nav-item ${path === '/dashboard' ? 'active' : ''}`}
        onClick={handleHomeClick}
      >
        <div className="mobile-nav-icon"><HomeIcon /></div>
        <span>Home</span>
      </Link>

      <Link
        to="/schedule"
        className={`mobile-nav-item ${path === '/schedule' ? 'active' : ''}`}
      >
        <div className="mobile-nav-icon"><ScheduleIcon /></div>
        <span>Schedule</span>
      </Link>

      <Link
        to="/events"
        className={`mobile-nav-item ${path.startsWith('/events') ? 'active' : ''}`}
      >
        <div className="mobile-nav-icon"><CalendarIcon /></div>
        <span>Events</span>
      </Link>

      <Link
        to="/campus-map"
        className={`mobile-nav-item ${path === '/campus-map' ? 'active' : ''}`}
      >
        <div className="mobile-nav-icon"><MapIcon /></div>
        <span>Map</span>
      </Link>

      <Link
        to="/user-details"
        className={`mobile-nav-item ${path === '/user-details' ? 'active' : ''}`}
      >
        <div className="mobile-nav-icon"><AccountIcon /></div>
        <span>Account</span>
      </Link>
    </nav>
  );
};

export default BottomNav;
